import { render, staticRenderFns } from "./CustomerNote.vue?vue&type=template&id=3c824e6d&"
import script from "./CustomerNote.vue?vue&type=script&lang=js&"
export * from "./CustomerNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports